
import { toTop } from '@/utils/tool/Tool'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
    props: ["post"],
    setup() {
        const router = useRouter()
        const tapPost = (name:string) =>{
            if (!name) return 
            toTop()
            router.push(`/post?file=${name}`)
        }
        const tapTag = (tag:string) => {
            if (!tag) return 
            toTop()
            router.push(`/tag?tag=${tag}`)
        }
        return {
            tapTag,
            tapPost
        }
    }
})
